<app-block-wrapper [_editable]="_editable" [style]="style">
  <div class="comparison-title">
    <h2>{{ title }}</h2>
    <div class="competitor-logo">
      <img [src]="competitorLogo.filename" [width]="96" [height]="96" alt="" />
    </div>
    <div class="picflow-logo">
      <img src="/assets/icons/special/circle-picflow-icon.svg" [width]="128" [height]="128" alt="" />
    </div>
  </div>

  <div class="group" *ngFor="let group of groups" [appStoryblok]="group._editable">
    <h3>{{ group.title }}</h3>

    <div class="empty-group" *ngIf="!group.items.length"></div>

    <div class="group-item" *ngFor="let item of group.items" [appStoryblok]="item._editable">
      <div
        class="feature-name"
        appTooltip=""
        [showOnMobile]="true"
        [tooltipHtmlContent]="item.feature?.text | storyblokRichText"
        [tooltipTitle]="item.feature?.title"
        [tooltipImageUrl]="item.feature?.image?.filename"
        [tooltipStyle]="'light'"
        [tooltipSize]="'big'"
        [skipDelay]="true"
        [class.has-hover]="(item.feature?.text | storyblokRichText)?.length > 10"
      >
        {{ item.feature?.title }}
      </div>

      <div class="separator"></div>

      <div class="competitor-value" [class.checked]="item.competitorValue === true">
        <ng-container *ngIf="!item.competitorCustomValue">
          <app-svg src="/assets/icons/check.svg" *ngIf="item.competitorValue === true"></app-svg>
          <app-svg src="/assets/icons/cross.svg" *ngIf="item.competitorValue === false"></app-svg>
        </ng-container>

        <span *ngIf="item.competitorCustomValue">{{ item.competitorCustomValue }}</span>
      </div>

      <div class="picflow-value" [class.checked]="item.picflowValue === true">
        <ng-container *ngIf="!item.picflowCustomValue">
          <app-svg src="/assets/icons/check-circle.svg" *ngIf="item.picflowValue === true"></app-svg>
          <app-svg src="/assets/icons/cross.svg" *ngIf="item.picflowValue === false"></app-svg>
        </ng-container>
        <span *ngIf="item.picflowCustomValue">{{ item.picflowCustomValue }}</span>
      </div>
    </div>
  </div>
</app-block-wrapper>
